<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    :close-on-click-modal="false"
  >
    <el-form
      ref="curdForm"
      :size="size"
      :model="curdForm"
      label-position="right"
      label-width="100px"
    >
      <el-form-item label="角色编号：" prop="roleCode" class="details">
        <span>{{ curdForm.roleCode }}</span>
      </el-form-item>
      <el-form-item label="角色名称：" prop="name" class="details">
        <span>{{ curdForm.roleName }}</span>
      </el-form-item>
      <el-form-item label="角色描述：" prop="description" class="details">
        <span>{{ curdForm.describe }}</span>
      </el-form-item>
      <!-- <el-form-item label="功能权限：" prop="menus">
        <treeSelet
          :data="Bus.menuTree"
          :defaultProps="props"
          multiple
          :nodeKey="nodeKey"
          :checkedKeys="nodeID"
          @getMenuIds="getMenuID"
        />
      </el-form-item> -->
      <el-form-item label="创建人：" prop="createUserName" class="details">
        <span>{{ curdForm.createUserName }}</span>
      </el-form-item>
      <el-form-item label="创建时间：" prop="createDate" class="details">
        <span>{{ curdForm.createDate }}</span>
      </el-form-item>
      <el-form-item label="显示顺序：" prop="index" class="details">
        <span>{{ curdForm.index }}</span>
      </el-form-item>
      <el-form-item label="备注：" prop="remark" class="details">
        <span>{{ curdForm.remark }}</span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn
        btntype="primary"
        title="关闭"
        @click.native="CUFlag = false"
      ></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
// import treeSelet from "@/components/treeSelet/index";
import Bus from "./Bus.js";
export default {
  components: { butn },
  data() {
    return {
      Bus,
      size: "small",
      curdTitle: "角色详情",
      CUFlag: false,
      Dflag: false,
      curdForm: {},
      props: {
        //树形
        label: "name",
        children: "children"
      },
      nodeKey: "apiId",
      nodeID: [] //选中ID
    };
  },
  methods: {
    create() {},
    update() {},
    retrieve() {},
    delete() {},
    getMenuID() {
      //获取所有被选中的key的数组
    }
  },
  mounted() {
    var _this = this;
    Bus.$on("details", function(item) {
      _this.CUFlag = true;
      _this.curdForm = item;
      // for (let menu of item.menus) {
      //   _this.nodeID.push(menu.apiId);
      // }
    });
  }
};
</script>
